import React from 'react';

export const LandscapeIcon = ({
  width = 24,
  height = 24,
  color = 'currentColor',
}) => (
  <svg
    width={width}
    height={height}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24 11.5858L22.4142 10L9.58579 10L8 11.5858L8 20.4142L9.58579 22L22.4142 22L24 20.4142L24 11.5858ZM22 20L22 12L10 12L10 20L22 20Z"
      fill={color}
    />
  </svg>
);
